<script lang="ts" setup>
import { FontAwesomeIcon, type FontAwesomeIconProps } from '@fortawesome/vue-fontawesome';
import type { BasicColor } from '@tailwind-preset/colors';

const props = withDefaults(
  defineProps<{
    active?: boolean;
    color?: BasicColor;
    prefixIcon?: FontAwesomeIconProps['icon'];
    shadow?: boolean;
    suffixIcon?: FontAwesomeIconProps['icon'];
    inverted?: boolean;
  }>(),
  {
    active: undefined,
  },
);

const colorClasses: Record<BasicColor, string> = {
  black: 'before:tw-bg-black',
  blue: 'before:tw-bg-blue',
  green: 'before:tw-bg-green',
  grey: 'before:tw-bg-grey-200',
  orange: 'before:tw-bg-orange',
  purple: 'before:tw-bg-purple',
  red: 'before:tw-bg-red',
  teal: 'before:tw-bg-teal',
  yellow: 'before:tw-bg-yellow',
};
</script>

<template>
  <button
    :class="[
      'tw-flex tw-items-center tw-gap-1.5 tw-overflow-hidden tw-whitespace-nowrap tw-rounded tw-border tw-px-2.5 tw-py-1.5 tw-text-sm tw-text-primary-900',
      props.color ? colorClasses[props.color] : undefined,
      {
        'before:tw-size-2 before:tw-rounded-full': props.color,
        'tw-border-grey-200 tw-bg-white': !props.inverted,
        'tw-border-grey-100 tw-bg-grey-100 tw-transition-colors tw-duration-100 hover:tw-bg-grey-200':
          props.inverted,
        'tw-shadow-[0_1px_2px_rgb(0_0_0_/_.1)]': props.shadow,
        'hover:tw-border-grey-300 hover:tw-bg-grey-100': !props.inverted && !props.shadow,
      },
    ]"
    type="button"
  >
    <FontAwesomeIcon v-if="props.prefixIcon" :icon="props.prefixIcon" />

    <slot></slot>

    <FontAwesomeIcon v-if="props.suffixIcon" class="tw-ml-auto" :icon="props.suffixIcon" />

    <FontAwesomeIcon
      v-if="props.active !== undefined"
      :class="[
        'tw-ml-auto tw-text-primary',
        {
          'tw-translate-x-6': !props.active,
          'tw-transition-transform tw-duration-100': props.active,
        },
      ]"
      :icon="['far', 'check']"
    />
  </button>
</template>
